import httpHubless from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'users/v2/app';
export default class UsersAPI {
  static deleteSelf() {
    return httpHubless.delete(`${API_BASE}/user/gdpr-delete`);
  }
  static checkNoAdminlessHubs() {
    return httpHubless.get(`${API_BASE}/gdpr-delete/adminless-hubs`);
  }
}